<template>
  <div class="schedule max-content">
    <top :title="nav_title" :color="theme_color"></top>
    <van-search v-model="keywords" placeholder="请输入搜索关键词" @search="onSearch" shape="round" background="#f7f7f7">
      <template #right-icon>
        <div @click="onSearch" class="search-icon">搜索</div>
      </template>
    </van-search>
    <div class="timeTabs-wrap2">
      <div class="timeTabs2">
        <div class="tab-item2" v-for="(item, index) in scheduleDate" :key="index" @click="switchDate(item)"
          :class="item == active ? 'active' : ''" :style="{
            background: item == active && theme_color ? theme_color : ''
          }">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="container">
      <van-collapse v-model="collapse_active" accordion :border="false">
        <div v-for="(item, index) in scheduleList" :key="index" :ref="`collapes_${item.id}`">
          <van-collapse-item
            :title="(item.daily_preview_title ? item.daily_preview_title : item.name) + ' ' + (item.hall_name ? item.hall_name : '')"
            :title-class="'collapes-title'" :name="index"
            :label="item.start_at.split(' ')[0] + ' ' + filterTime(item.start_at) + '-' + filterTime(item.end_at)">
            <div class="detail" v-for="sd in item.chapters" :key="sd.id">
              <div class="more" :ref="`chapter_${sd.id}`">
                <span class="time" v-if="sd.start_at">{{ filterTime(sd.start_at) }}-{{
                  filterTime(sd.end_at)
                }}</span>
                <div class="name">{{ sd.name }}</div>
                <p class="live-detail" v-if="meeting_id != 473">
                  <span v-if="item.live_status != 3 && item.is_show_schedule && sd.is_show_live" @click="
                    goDetail(item.id, sd.id)">{{ meeting_id == 537 ? '点击跳转本节日程' : '点击查看日程直录播' }} <van-icon
                      name="arrow" /></span>
                </p>
                <div class="speakers" v-if="(sd.chairman_writers &&
                  sd.chairman_writers.length) ||
                  (sd.host_writers &&
                    sd.host_writers.length) ||
                  (sd.discussor_writers &&
                    sd.discussor_writers.length) ||
                  (sd.titles && sd.titles.length) ||
                  (sd.auto_writers && sd.auto_writers.length)
                ">
                  <div v-if="sd.chairman_writers &&
                    sd.chairman_writers.length
                  ">
                    主席：
                    <p v-for="name in sd.chairman_writers" :key="name.id" @click="goExpertDetail(name.id)">
                      {{ name.name
                      }}<span v-if="name.company && meeting_id!=581">({{ name.company }})</span>
                      <van-icon name="arrow" />
                    </p>
                  </div>
                  <div v-if="sd.host_writers &&
                    sd.host_writers.length
                  ">
                    主持专家：
                    <p v-for="name in sd.host_writers" :key="name.id" @click="goExpertDetail(name.id)">
                      {{ name.name
                      }}<span v-if="name.company && meeting_id!=581">({{ name.company }})</span>
                      <van-icon name="arrow" />
                    </p>
                  </div>

                  <div v-if="sd.discussor_writers && sd.discussor_writers.length">

                    讨论专家：
                    <p v-for="name in sd.discussor_writers" :key="name.id" @click="goExpertDetail(name.id)">
                      {{ name.name
                      }}<span v-if="name.company && meeting_id!=581">({{ name.company }})</span><van-icon name="arrow" />
                    </p>
                  </div>

                  <div v-if="sd.titles && sd.titles.length">
                    <div v-for="val in sd.titles" :key="val.id">
                      {{ val.title }}:
                      <p v-for="name in val.writers" :key="name.id" @click="goExpertDetail(name.id)">
                        {{ name.name
                        }}<span v-if="name.company && meeting_id!=581">({{ name.company }})</span><van-icon name="arrow" />
                      </p>
                    </div>
                  </div>

                  <div v-if="sd.auto_writers && sd.auto_writers.length">
                    <div v-for="(item, i) in sd.auto_writers" :key="i">
                      {{ item.type_name }}：

                      <p v-for="name in item.writers" :key="name.id" @click="goExpertDetail(name.id)">
                        {{ name.name
                        }}<span v-if="name.company && meeting_id!=581">({{ name.company }})</span><van-icon name="arrow" />
                      </p>
                    </div>
                    <br />
                  </div>
                </div>

                <div class="chapter" v-for="(ele, index) in sd.details" :key="ele.id">
                  <div class="main" :style="{
                    'border-left-width':
                      index == sd.details.length - 1 ? '0px' : '2px'
                  }">
                    <div class="title">
                      {{ ele.name }}<span v-if="ele.video_url">(已生成录播)</span>
                    </div>
                    <div v-for="(writer, wi) in ele.writers" :key="writer.id">
                      <p @click="goExpertDetail(writer.id)">
                        <span> · </span>{{ writer.name }}<span v-if="writer.company && meeting_id!=581">({{ writer.company
                        }})</span><van-icon name="arrow" />
                      </p>

                      <p v-if="chapter_id == 7878">
                        <span style="opacity: 0;"> · </span><span>{{ teams_1[wi] }}</span>
                      </p>
                      <p v-if="chapter_id == 7879">
                        <span style="opacity: 0;"> · </span><span>{{ teams_2[wi] }}</span>
                      </p>
                      <p v-if="chapter_id == 7880">
                        <span style="opacity: 0;"> · </span><span>{{ teams_3[wi] }}</span>
                      </p>
                      <p v-if="chapter_id == 7881">
                        <span style="opacity: 0;"> · </span><span>{{ teams_4[wi] }}</span>
                      </p>
                    </div>

                  </div>
                  <div class="play" @click="goDetail(item.id, sd.id)" v-if="item.live_status != 3 && item.is_show_schedule && sd.is_show_live">
                    <img src="../../../assets/images/System/play_icon.png" alt="">
                    <p>播放</p>
                  </div>
                  <div class="light" v-if="ele.state == 0">
                    <div class="color-bg">· {{ ele.time }} ·</div>
                    <div class="status" v-if="meeting_id != 596">未开始</div>
                  </div>
                  <div class="light now" v-if="ele.state == 1">
                    <div class="color-bg">· {{ ele.time }} ·</div>
                    <div class="status" v-if="meeting_id != 596">进行中</div>
                  </div>
                  <div class="light end" v-if="ele.state == 2">
                    <div class="color-bg">· {{ ele.time }} ·</div>
                    <div class="status" v-if="meeting_id != 596">已结束</div>
                  </div>


                </div>
              </div>
            </div>
          </van-collapse-item>
        </div>
      </van-collapse>
    </div>


  </div>
</template>
<script>
import { Toast, Icon, Collapse, CollapseItem } from "vant";
import { MeetingScheduleDetails, MeetingsSchedule } from "../../../config/interface.js";
import Top from "../components/Top";

export default {
  components: {
    Top,
    Icon,
    Collapse,
    CollapseItem
  },
  data() {
    return {
      chapter_id: 0,
      meeting_id: 0,
      scheduleDetails: {},
      nav_title: "日程详情",
      color: "",
      teams_1: ['李维敏团队和殷敏毅团队', '薛冠华团队和叶猛团队', '孟庆友团队', '陈跃鑫团队'],
      teams_2: ['刘晓兵团队和叶开创团队和王瑞华团队', '梁卫团队和叶猛团队'],
      teams_3: ['李维敏团队和殷敏毅团队', '郭相江团队', '曾嵘团队和宋小军团队'],
      teams_4: ['刘晓兵团队和王瑞华团队', '薛冠华团队和梁卫团队和郭相江团队'],
      meetingSchedule: {},
      scheduleDate: [],
      keywords: '',
      active: 0,
      activeName: '',
      theme_color: "",
      scheduleList: [],
      hall_id: ' ',
      collapse_active: '',
      is_switch: false

    };
  },
  mounted() {
    this.chapter_id = this.$route.query.chapter_id;
    this.meeting_id = this.$route.query.meeting_id;
    this.hall_id = this.$route.query.id;
    this.button_id = this.$route.query.button_id
    this.getSchedule();
    // this.sessionSchedule();
    if (this.meeting_id == 473) {
      this.color = "#0A318E";
    }
  },
  methods: {
    //全部日程详情
    getSchedule() {
      const url = MeetingsSchedule;
      let params = {
        meeting_id: this.meeting_id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          console.log('日程详情', res.data)
          var data = res.data;
          this.meetingSchedule = data.sessions;
          if (data.meeting.theme_color_hex) {
            this.theme_color = data.meeting.theme_color_hex;
          } else {
            this.theme_color = "#901D22";
          }
          this.scheduleDate = Object.keys(this.meetingSchedule).sort();
          this.active = this.scheduleDate[0]
          let save_date = localStorage.getItem('schedule_date')
          save_date = save_date ? save_date : this.active
          console.log(save_date)
          if (this.scheduleDate.indexOf(save_date) > -1) {
            let index = this.scheduleDate.indexOf(save_date);
            this.switchDate(this.scheduleDate[index]);
          }
        }
      });
    },
    //切换日期
    switchDate(date) {
      this.scheduleList = this.meetingSchedule[date];
      for (var i = 0; i < this.scheduleList.length; i++) {
        if (this.scheduleList[i].id == this.hall_id) {
          this.collapse_active = i
        }
      }

      if (date != this.active && this.is_switch) {
        console.log(date, this.active)
        this.collapse_active = -1
        this.hall_id = -1
      }
      this.active = date;
      this.$nextTick(() => {
        let el = ''
        let refName = ''
        if (this.chapter_id) {
          refName = `chapter_${this.chapter_id}`
        } else {
          refName = `collapes_${this.hall_id}`
        }
        if (refName && this.$refs[refName]) {
          el = this.$refs[refName][0];
          console.log(el)
          el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
          this.is_switch = true
        }

      })
      // localStorage.removeItem("schedule_date", date);

    },
    sessionSchedule() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: ""
      });
      const url = MeetingScheduleDetails;
      let params = {
        chapter_id: this.chapter_id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        Toast.clear();
        if (res.code == 0) {
          var data = res.data;
          this.scheduleDetails = data;
          if (res.data.theme_color_hex) {
            this.color = res.data.theme_color_hex
          } else {
            this.color = '#901D22'
          }

        }
      });
    },
    filterTime(date) {
      return date.split(" ")[1].substring(0, 5);
    },
    goDetail(parallel_session_id, id) {
      this.$router.push({
        path: "/vascularNews/meeting/liveDetail",
        query: {
          meeting_id: this.meeting_id,
          id: parallel_session_id,
          chapter_id: id
        }
      });
    },
    goExpertDetail(id) {
      this.$router.push({
        path: "/vascularNews/expert/detail",
        query: { meeting_id: this.meeting_id, writer_id: id }
      });
    },
    onSearch() {
      if (this.keywords) {
        this.$router.push({
          path: "/vascularnews/schedule/result",
          query: {
            id: this.meeting_id,
            button_id: this.button_id,
            keywords: this.keywords
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.van-search__content {
  background: white;
}

.timeTabs2 {
  padding: 0px 12px 5px;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;

  .tab-item2 {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    width: 90px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    border-radius: 5px;
    margin: 5px 15px 5px 0;
    background: #ffffff;
    cursor: pointer;
  }

  .active {
    color: #fff;
    background: #901d22;
  }
}

.collapes-title {
  font-weight: bold !important;
  font-size: 18px !important;
}

.container {
  padding: 0 15px;
}

.van-collapse {
  border-radius: 5px;
  overflow: hidden;
}

.van-collapse-item__content .detail {
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
  padding-top: 15px
}

.van-collapse-item__content {
  padding-top: 0;
}

.van-collapse-item__content .detail:last-child {
  border-bottom: none !important;
}

.schedule {
  .detail {

    // padding: 15px 0;
    .cell {
      background: white;
      margin: 15px 0;
      border-radius: 10px;
    }

    .head {
      display: flex;
      padding: 15px;

      .left {
        width: 100%;

        .name {
          line-height: 19px;
          // height: 19px;
          margin-bottom: 13px;
          font-size: 16px;
          color: #1c1c1c;
        }

        .time {
          line-height: 14px;
          color: #666666;
          font-size: 12px;
        }
      }
    }

    .more {
      // padding: 15px;
      // border-top: 1px solid #ebebeb;

      .time {
        height: 20px;
        border-radius: 10px;
        background: #ffe6e7;
        line-height: 20px;
        color: #901d22;
        font-size: 14px;
        margin: 10px 0;
        padding: 0 10px;
      }

      .name {
        line-height: 22px;
        font-size: 16px;
        color: #131313;
        margin: 15px 0;
      }

      .live-detail {
        display: flex;
        justify-content: flex-end;

        span {
          background: #FFE6E7;
          width: 157px;
          border-radius: 10px;
          color: #901D22;
          font-size: 13px;
          line-height: 20px;
          text-align: center;
          margin-bottom: 15px;
          display: block;
        }

      }


      .speakers {
        background: #f7f7f7;
        border-radius: 5px;
        padding: 15px 10px;
        color: #901d22;
        font-size: 15px;
        line-height: 21px;
        margin-bottom: 20px;

        &>div {
          margin-bottom: 15px;
        }

        &>div:last-child {
          margin-bottom: 0;
        }

        p {
          color: #131313;
          font-size: 13px;
          margin-top: 5px;
          line-height: 18px;
          cursor: pointer;
        }
      }

      .chapter {
        position: relative;

        .title {
          font-size: 14px;
          color: #131313;
          margin-bottom: 13px;
          line-height: 17px;
        }

        p {
          color: #666666;
          font-size: 12px;
          line-height: 14px;
        }

        .main {
          margin-left: 26px;
          padding-left: 45px;
          border-left: 2px dashed #e4e4e4;
          padding-bottom: 40px;
          padding-right: 30px;
        }

        .main.last {
          border: 0;
          padding-bottom: 10px;
        }
      }

      .light {
        border-radius: 3px;
        width: 57px;
        font-size: 12px;
        text-align: center;
        position: absolute;
        left: 0;
        top: 0;

        .color-bg {
          background: linear-gradient(90deg, #4c82e3 0%, #204ea1 100%);
          color: white;
          line-height: 23px;
          white-space: nowrap;
        }

        .status {
          background: #e2ecff;
          color: #204ea1;
          line-height: 24px;
        }
      }

      .light.now {
        .color-bg {
          background: linear-gradient(90deg, #c33e47 0%, #901d22 100%);
        }

        .status {
          background: #ffebec;
          color: #901d22;
        }
      }

      .light.end {
        .color-bg {
          background: linear-gradient(90deg, #b7b7b7 0%, #929292 100%);
        }

        .status {
          background: #f7f7f7;
          color: #999999;
        }
      }

      .play {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
        }

        p {
          color: #901D22;
          font-size: 10px;
        }
      }
    }
  }
}

.expert {

  // display: flex;
  img {
    width: 18px;
  }

  span {
    margin-left: 5px;
    margin-right: 5px;
    // color:$color-black;
    line-height: 22px;
    font-size: 12px;
  }

  p {
    flex: 1;
    text-align: justify;
    font-size: 12px;
    // color:#999;
    line-height: 22px;
  }

  .text-top {
    vertical-align: top;
    margin: 0 5px 0 2px;
  }

  .names {
    margin: 0 23px;
  }
}
</style>
<!-- <style>
@media screen and (min-width: 580px) {
  #app {
    max-width: 90% !important;
  }
}
</style> -->


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/ScheduleList.vue